import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { createRef, Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import compose from 'recompose/compose';
import { authLogout } from '../../actions/AuthActions';
import OtherClickListener from '../../events/OtherClickListener';
import { getFullName, isClient } from '../../helpers/auth';
import { propFunc, propShape, PropTypesAuthToken, } from '../../helpers/custom-prop-types';
class HeaderMenuButton extends Component {
    constructor(props) {
        super(props);
        this.toggleMenu = () => {
            const { open } = this.state;
            this.setState({ open: !open });
        };
        this.closeMenu = () => {
            this.setState({ open: false });
        };
        this.onClickLogout = () => {
            const { logout } = this.props;
            logout();
        };
        this.clickRef = createRef();
        this.clickListenerNo = null;
        this.state = {
            open: false,
        };
    }
    componentDidMount() {
        this.clickListenerNo = OtherClickListener.setListener(this.clickRef.current, this.closeMenu);
    }
    componentWillUnmount() {
        OtherClickListener.deleteListener(this.clickListenerNo);
    }
    render() {
        const { auth, profile } = this.props;
        const organization = profile.organization || {};
        const { open } = this.state;
        return (_jsxs("div", Object.assign({ className: 'menu-icon btn-account' }, { children: [_jsxs("button", Object.assign({ className: 'material-icons hov-icon', disabled: !profile.id, onClick: this.toggleMenu, ref: this.clickRef, tabIndex: '-1', type: 'button' }, { children: ["person", _jsx("i", Object.assign({ className: 'material-icons md-14 sub-icon' }, { children: "keyboard_arrow_down" }))] })), _jsx("div", Object.assign({ className: `account-menu icon-menu-body ${open ? 'is-visible' : ''}` }, { children: _jsxs("dl", { children: [_jsxs("dt", { children: [_jsx("span", Object.assign({ className: 'name ellipsis_text' }, { children: `${getFullName(profile) || (profile && profile.email)} 様` })), organization.name && (_jsx("span", Object.assign({ className: 'font-size-0-8rem organization ellipsis_text' }, { children: organization.name })))] }), _jsx("dd", { children: _jsxs("ul", { children: [_jsx("li", { children: _jsxs(Link, Object.assign({ target: '_blank', to: '/mypage/profile' }, { children: [_jsx("i", Object.assign({ className: 'material-icons link-text' }, { children: "portrait" })), "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB"] })) }), isClient(auth) && (_jsxs(_Fragment, { children: [_jsx("li", { children: _jsxs(Link, Object.assign({ to: '/mypage/favorites' }, { children: [_jsx("i", Object.assign({ className: 'material-icons link-text' }, { children: "stars" })), "\u304A\u6C17\u306B\u5165\u308A\u306E\u30B3\u30F3\u30B5\u30EB"] })) }), _jsx("li", { children: _jsxs(Link, Object.assign({ to: '/proffit_mart' }, { children: [_jsx("i", Object.assign({ className: 'material-icons link-text' }, { children: "important_devices" })), "Proffit Mart"] })) })] })), _jsx("li", { children: _jsx("button", Object.assign({ onClick: this.onClickLogout, type: 'button' }, { children: "\u30ED\u30B0\u30A2\u30A6\u30C8" })) })] }) })] }) }))] })));
    }
}
HeaderMenuButton.propTypes = {
    auth: PropTypesAuthToken.isRequired,
    logout: propFunc().isRequired,
    profile: propShape().isRequired,
};
const mapStateToProps = (state) => ({
    auth: state.auth,
    profile: state.profile,
});
const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(authLogout()),
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(HeaderMenuButton);
